function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { j as e } from "./index.es33.js";
import { clsx as m } from "./index.es105.js";
import { Typography as h } from "./index.es35.js";
import "./index.es36.js";
import { Header as f } from "./index.es676.js";
import { SortingIndicator as x } from "./index.es677.js";
import t from "./index.es600.js";
import l from "./index.es198.js";
var b = function b(_ref) {
  var n = _ref.header,
    o = _ref.accessor,
    r = _ref.isUnsortable,
    a = _ref.isInnerSorted,
    i = _ref.isAlreadySorted,
    d = _ref.isSortOrder,
    c = _ref.onClick,
    _ref$withoutRightPadd = _ref.withoutRightPadding,
    p = _ref$withoutRightPadd === void 0 ? !1 : _ref$withoutRightPadd,
    s = _ref.isShortColumn;
  return e.jsx(h.Body2, {
    as: "th",
    className: m("table__thead-cell", t.head, _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, t.withSortingIndicator, !r), t.headUnSortable, r), t.shortHeadColumn, s), "withoutRightPadding", p)),
    onClick: function onClick() {
      return c === null || c === void 0 ? void 0 : c(o);
    },
    children: e.jsxs("div", {
      className: m("table__cell-inner", l.cellInner, _defineProperty(_defineProperty(_defineProperty({}, l.cellInnerUnSortable, r), l.cellInnerSorted, a), l.cellInnerSortOrder, d)),
      children: [e.jsx(f, {
        title: n
      }), !r && e.jsx(x, {
        isAlreadySorted: i
      })]
    })
  }, o);
};
export { b as Cell };